const sortAfterTime = (arr: { [x: string]: any }[]) => arr.sort((x, y) => x.timestamp - y.timestamp);

export default sortAfterTime;
